// removed by extract-text-webpack-plugin
module.exports = {"middleSectionClassName":"Sidebar__middleSectionClassName__3d3cb921","flexButtons":"Sidebar__flexButtons__3d3cb921","saveSearchContainer":"Sidebar__saveSearchContainer__3d3cb921","onHold":"Sidebar__onHold__3d3cb921","tradeProcurementCta":"Sidebar__tradeProcurementCta__3d3cb921","depositWrapper":"Sidebar__depositWrapper__3d3cb921"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/Sidebar.scss
// module id = 2277
// module chunks = 7